import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import { useQuery } from '@apollo/client';
import { USER_TRACKINGS } from '../../pages/tester/graphql';

import {
  Table,
  Header,
  Row,
  HeaderCell,
  Cell,
  Body,
  HeaderText,
  CellText,
  Loader,
  LoaderContainer,
} from './styles';

const UserTrackingTable = ({ userId }) => {
  const {
    data = {},
    error,
    loading,
  } = useQuery(USER_TRACKINGS, {
    variables: {
      userId,
    },
  });

  const { user: { userTrackings = [] } = {} } = data;

  if (error) {
    return null;
  }

  if (loading) {
    return (
      <LoaderContainer>
        <Loader data-loader="user-tracking-loader" />
      </LoaderContainer>
    );
  }

  return (
    <Table basic="very">
      <Header>
        <Row>
          <HeaderCell>
            <HeaderText>
              Last Loggin
            </HeaderText>
          </HeaderCell>
          <HeaderCell>
            <HeaderText>
              Location
            </HeaderText>
          </HeaderCell>
          <HeaderCell>
            <HeaderText>
              IP Address
            </HeaderText>
          </HeaderCell>
        </Row>
      </Header>

      <Body>
        {userTrackings.map((userTracking) => (
          <Row>
            <Cell>
              <CellText>
                {moment(userTracking.createdAt).tz('America/New_York').format('MM/DD/YYYY hh:mm A')}
              </CellText>
            </Cell>
            <Cell>
              <CellText>
                {userTracking.location}
              </CellText>
            </Cell>
            <Cell>
              <CellText>
                {userTracking.ip}
              </CellText>
            </Cell>
            <Cell />
          </Row>
        ))}
      </Body>
    </Table>
  );
};

UserTrackingTable.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default UserTrackingTable;
